import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import Button from '../../../../core/form/Button';
import Breadcrumb from '../../../../core/layout/Breadcrumb';
import Card from '../../../../core/layout/Card';
import Column from '../../../../core/layout/Column';
import Row from '../../../../core/layout/Row';
import Separator from '../../../../core/layout/Separator';
import { get } from 'lodash';
import ContentMasteryTestFailureAttemptRateTableContainer from './mastery-test/ContentMasteryTestFailureAttemptRateTableContainer';
import ContentMasteryTestSpeechRateTableContainer from './mastery-test/ContentMasteryTestSpeechRateTableContainer';
import ContentMasteryTestRepeatRateTableContainer from './mastery-test/ContentMasteryTestRepeatRateTableContainer';
import ContentMasteryTestErrorRateTableContainer from './mastery-test/ContentMasteryTestErrorRateTableContainer';
import KpiReferenceMonth from '../../commons/KpiReferenceMonth';
import ContentMasteryTestDetailSummary from './ContentMasteryTestDetailSummary';

const ContentMasteryTestDetailScene = (props) => (
  <div>
    <Breadcrumb
      fetching={props.isLoading}
      crumbs={[
        {
          text: "KPI's Content",
          link: `/kpis/content`,
        },
        {
          text: get(props.course, 'name'),
          link: `/kpis/content/course/${get(props.course, 'id')}/mastery-details`,
        },
        ...(props.module
          ? [
              {
                text: get(props.module, 'name'),
                link: `/kpis/content/course/${get(props.course, 'id')}/module/${get(
                  props.module,
                  'id'
                )}/mastery-details`,
              },
            ]
          : []),
        ...(props.masteryTest
          ? [
              {
                text: get(props.masteryTest, 'modulePercentageToActive'),
                link: `/kpis/content/course/${get(props.course, 'id')}/module/${get(
                  props.module,
                  'id'
                )}/mastery-test/${get(props.masteryTest, 'id')}/mastery-details`,
              },
            ]
          : []),
      ]}
    />
    <Card
      loading={props.isLoading}
      title={`
        ${get(props.course, 'id', false) ? 'Course / Modules' : ''}
        ${get(props.module, 'id', false) ? ' / Mastery Tests' : ''}
        ${get(props.masteryTest, 'id', false) ? ' / Items' : ''}
      `}
      actions={<Button icon="arrow-left" label="back" onClick={() => browserHistory.goBack()} />}
    >
      <KpiReferenceMonth />
    </Card>
    <Separator />
    <Card
      loading={props.isLoading}
      title={`Summary - ${
        props.masteryTest
          ? `Mastery Test: ${props.masteryTest.modulePercentageToActive}%`
          : props.module
          ? `Module: ${props.module.name}`
          : `Course: ${props.course?.name}`
      }`}
    >
      <ContentMasteryTestDetailSummary />
    </Card>
    <Separator />
    <Card isLoading={props.isLoading}>
      <Row>
        <Column size={6}>
          <ContentMasteryTestFailureAttemptRateTableContainer
            courseId={get(props.course, 'id')}
            moduleId={get(props.module, 'id')}
            masteryTestId={get(props.masteryTest, 'id')}
          />
        </Column>
        <Column size={6}>
          <ContentMasteryTestSpeechRateTableContainer
            courseId={get(props.course, 'id')}
            moduleId={get(props.module, 'id')}
            masteryTestId={get(props.masteryTest, 'id')}
          />
        </Column>
      </Row>
      <Separator />
      <Row>
        <Column size={6}>
          <ContentMasteryTestRepeatRateTableContainer
            courseId={get(props.course, 'id')}
            moduleId={get(props.module, 'id')}
            masteryTestId={get(props.masteryTest, 'id')}
          />
        </Column>
        <Column size={6}>
          <ContentMasteryTestErrorRateTableContainer
            courseId={get(props.course, 'id')}
            moduleId={get(props.module, 'id')}
            masteryTestId={get(props.masteryTest, 'id')}
          />
        </Column>
      </Row>
    </Card>
  </div>
);

ContentMasteryTestDetailScene.propTypes = {
  course: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  module: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  masteryTest: PropTypes.shape({
    id: PropTypes.string.isRequired,
    modulePercentageToActive: PropTypes.number.isRequired,
  }),
  isLoading: PropTypes.bool.isRequired,
};

export default ContentMasteryTestDetailScene;
